export default "__VITE_ASSET__fc1ba34f__"